import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';

export default function DeleteDialogueBox(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }
    return (
        <div className="ws-6">

            <Modal open={param.param} onClose={() => returnValue(2)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >
                <div className="box">

                    <div className="box-header-main well">
                        <h2><i className="fa fa-question-circle"></i> Confirm ?</h2>
                    </div>
                    
                    <div className="box-content">
                        {param?.description && <div dangerouslySetInnerHTML={{ __html: param?.description }} />}

                        <span>Are you sure you want to {param.message} ?</span>
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn edit width100 height35" onClick={() => returnValue(1)} > Yes</button>
                        <button className="icon-btn delete width100 height35" onClick={() => returnValue(2)} > No</button>
                    </div>

                </div>
            </Modal>

        </div>
    )
}